/**
 * @flow
 * @relayHash b2505df099eaa338281fdfede837337d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RefreshUpsTrackingInput = {|
  shipmentId: string
|};
export type RefreshUpsTrackingMutationVariables = {|
  input: RefreshUpsTrackingInput
|};
export type RefreshUpsTrackingMutationResponse = {|
  +refreshUpsTracking: {|
    +trackingEvents: $ReadOnlyArray<{|
      +id: string,
      +status: string,
      +description: ?string,
      +location: ?string,
      +eventTimestamp: ?any,
      +createdAt: any,
    |}>
  |}
|};
export type RefreshUpsTrackingMutation = {|
  variables: RefreshUpsTrackingMutationVariables,
  response: RefreshUpsTrackingMutationResponse,
|};
*/


/*
mutation RefreshUpsTrackingMutation(
  $input: RefreshUpsTrackingInput!
) {
  refreshUpsTracking(input: $input) {
    trackingEvents {
      id
      status
      description
      location
      eventTimestamp
      createdAt
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "RefreshUpsTrackingInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "refreshUpsTracking",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RefreshUpsTrackingPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "trackingEvents",
        "storageKey": null,
        "args": null,
        "concreteType": "ShipmentTrackingEvent",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "eventTimestamp",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "RefreshUpsTrackingMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "RefreshUpsTrackingMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "RefreshUpsTrackingMutation",
    "id": null,
    "text": "mutation RefreshUpsTrackingMutation(\n  $input: RefreshUpsTrackingInput!\n) {\n  refreshUpsTracking(input: $input) {\n    trackingEvents {\n      id\n      status\n      description\n      location\n      eventTimestamp\n      createdAt\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '765a64de909915f8aa59e4ee40007690';
module.exports = node;
